import React, { useState, useEffect } from "react";
import {
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Link,
    Checkbox,
    FormControlLabel,
    Box,
    FormGroup,
    Paper
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export default function PostulacionDetailsDialog({ open, onClose, postulacion, formatFecha }) {
    const [documentosValidados, setDocumentosValidados] = useState({});

    useEffect(() => {
        if (postulacion && postulacion.documentosValidados) {
            setDocumentosValidados(postulacion.documentosValidados);
        } else {
            setDocumentosValidados({
                cv: { valido: false, invalido: false },
                certificados: []
            });
        }
    }, [postulacion]);

    const handleCheckboxChange = async (tipo, index = null, validacion) => {
        let updatedDocumentosValidados = { ...documentosValidados };

        if (tipo === "cv") {
            updatedDocumentosValidados.cv = {
                valido: validacion === 'valido' ? !documentosValidados.cv?.valido : false,
                invalido: validacion === 'invalido' ? !documentosValidados.cv?.invalido : false
            };
        } else if (tipo === "certificados") {
            if (!updatedDocumentosValidados.certificados[index]) {
                updatedDocumentosValidados.certificados[index] = { valido: false, invalido: false };
            }
            updatedDocumentosValidados.certificados[index] = {
                valido: validacion === 'valido' ? !updatedDocumentosValidados.certificados[index].valido : false,
                invalido: validacion === 'invalido' ? !updatedDocumentosValidados.certificados[index].invalido : false
            };
        }

        setDocumentosValidados(updatedDocumentosValidados);

        if (postulacion.id) {
            const docRef = doc(db, "postulaciones", postulacion.id);
            try {
                await updateDoc(docRef, { "documentosValidados": updatedDocumentosValidados });
            } catch (error) {
                console.error("Error al actualizar la validación de documentos:", error);
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            {postulacion && (
                <>
                    <DialogTitle>
                        <Typography variant="h5" component="div" sx={{ textAlign: 'center', color: '#2196f3' }}>
                            Detalles de la Postulación
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            {/* ... Resto de la información (Información Personal, Académica, etc.) ... */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mt: 2, mb: 1, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>Información Personal</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Nombres y Apellidos:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.nombresApellidos}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Tipo de Documento:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.tipoDocumento}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Número de Documento:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.numeroDocumento}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Fecha de Nacimiento:</strong></Typography>
                                <Typography>{formatFecha(postulacion.informacionPersonal.fechaNacimiento)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Lugar de Nacimiento:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.lugarNacimiento}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Género:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.genero}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Estado Civil:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.estadoCivil}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Dirección de Residencia:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.direccionResidencia}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Teléfono Fijo:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.telefonoFijo}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Teléfono Celular:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.telefonoCelular}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Correo Electrónico:</strong></Typography>
                                <Typography>{postulacion.informacionPersonal.correoElectronico}</Typography>
                            </Grid>

                            {/* Información Académica */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>Información Académica</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Título de obtenido:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.tituloMedico}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Universidad:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.universidad}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Fecha de Grado:</strong></Typography>
                                <Typography>{formatFecha(postulacion.informacionAcademica.fechaGrado)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>País donde Obtuvo el Título:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.paisTitulo}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>¿Título Convalidado en Colombia?:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.tituloConvalidado}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Número de Resolución de Convalidación:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.numeroResolucion}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Especialización:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.especializacion}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Universidad de Especialización:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.universidadEspecializacion}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Fecha Inicio Especialización:</strong></Typography>
                                <Typography>{formatFecha(postulacion.informacionAcademica.fechaInicioEspecializacion)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Fecha Fin Especialización:</strong></Typography>
                                <Typography>{formatFecha(postulacion.informacionAcademica.fechaFinEspecializacion)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Otra Información Académica:</strong></Typography>
                                <Typography>{postulacion.informacionAcademica.otraInfoAcademica}</Typography>
                            </Grid>

                            {/* Experiencia Laboral */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>Experiencia Laboral</Typography>
                            </Grid>
                            {postulacion.experienciaLaboral.map((exp, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Entidad:</strong></Typography>
                                        <Typography>{exp.entidad}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Cargo:</strong></Typography>
                                        <Typography>{exp.cargo}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Fecha de Inicio:</strong></Typography>
                                        <Typography>{formatFecha(exp.fechaInicio)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Fecha de Fin:</strong></Typography>
                                        <Typography>{formatFecha(exp.fechaFin)}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography><strong>Funciones:</strong></Typography>
                                        <Typography>{exp.funciones}</Typography>
                                    </Grid>
                                </React.Fragment>
                            ))}

                            {/* Certificaciones y Habilidades */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>Certificaciones y Habilidades</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>¿Tiene Tarjeta Profesional?:</strong></Typography>
                                <Typography>{postulacion.certificacionesYHabilidades.tieneTarjetaProfesional}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Número de Tarjeta Profesional:</strong></Typography>
                                <Typography>{postulacion.certificacionesYHabilidades.numeroTarjetaProfesional}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Cursos Adicionales:</strong></Typography>
                                <Typography>{postulacion.certificacionesYHabilidades.cursosAdicionales}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Idiomas:</strong></Typography>
                                <Typography>{postulacion.certificacionesYHabilidades.idiomas}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Habilidades Informáticas:</strong></Typography>
                                <Typography>{postulacion.certificacionesYHabilidades.habilidadesInformaticas}</Typography>
                            </Grid>
                            {/* Lista de certificaciones */}
                            {postulacion.certificacionesYHabilidades.certificaciones.map((cert, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Nombre:</strong></Typography>
                                        <Typography>{cert.nombre}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Entidad:</strong></Typography>
                                        <Typography>{cert.entidad}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography><strong>Fecha de Expedición:</strong></Typography>
                                        <Typography>{formatFecha(cert.fechaExpedicion)}</Typography>
                                    </Grid>
                                </React.Fragment>
                            ))}

                            {/* Información Adicional */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>Información Adicional</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>¿Tiene alguna discapacidad?:</strong></Typography>
                                <Typography>{postulacion.informacionAdicional.tieneDiscapacidad}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>¿Pertenece a alguna minoría étnica?:</strong></Typography>
                                <Typography>{postulacion.informacionAdicional.perteneceMinoria}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Aspiración Salarial:</strong></Typography>
                                <Typography>{postulacion.informacionAdicional.aspiracionSalarial}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography><strong>Disponibilidad para Viajar:</strong></Typography>
                                <Typography>{postulacion.informacionAdicional.disponibilidadViajar}</Typography>
                            </Grid>
                            <Grid item xs={12}>
    <Typography variant="h6" sx={{ mt: 3, mb: 1, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>Referencias Personales</Typography>
    {postulacion.informacionAdicional.referencias.map((ref, index) => (
        <React.Fragment key={index}>
            <Grid item xs={12} sm={4}>
                <Typography><strong>Nombre:</strong> {ref.nombre}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Typography><strong>Teléfono:</strong> {ref.telefono}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Typography><strong>Relación:</strong> {ref.relacion}</Typography>
            </Grid>
        </React.Fragment>
    ))}
</Grid>
<Grid item xs={12} sm={6}>
    <Typography><strong>¿Tiene RETHUS?:</strong></Typography>
    <Typography>{postulacion.informacionAdicional.tieneRethus}</Typography>
</Grid>

                            {/* Validación de Documentos */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mt: 3, mb: 2, borderBottom: '1px solid #ccc', paddingBottom: 1, color: '#424242' }}>
                                    Validación de Documentos
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
    <Paper elevation={3} sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        <Typography variant="h6" sx={{ mb: 2, color: '#3f51b5' }}>CV:</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Link href={postulacion.archivos.cvUrl} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none' }}>
                <Button variant="contained" color="primary" startIcon={<CloudDownloadIcon />} size="large">
                    Descargar CV
                </Button>
            </Link>
        </Box>
        <FormGroup>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={documentosValidados.cv?.valido || false}
                        onChange={() => handleCheckboxChange("cv", null, 'valido')}
                        color="success"
                        icon={<HighlightOffIcon sx={{ fontSize: 30 }} />}
                        checkedIcon={<CheckCircleOutlineIcon sx={{ fontSize: 30, color: 'green' }} />}
                    />
                }
                label={<Typography variant="body1" sx={{fontWeight: 500}}>Válido</Typography>}
                sx={{ mb: 1 }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={documentosValidados.cv?.invalido || false}
                        onChange={() => handleCheckboxChange("cv", null, 'invalido')}
                        color="error"
                        icon={<HighlightOffIcon sx={{ fontSize: 30 }} />}
                        checkedIcon={<CheckCircleOutlineIcon sx={{ fontSize: 30, color: 'red' }} />}
                    />
                }
                label={<Typography variant="body1" sx={{fontWeight: 500}}>Inválido</Typography>}
                
            />
        </FormGroup>
    </Paper>
</Grid>
<Grid item xs={12} sm={6}>
    <Paper elevation={3} sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        <Typography variant="h6" sx={{ mb: 2, color: '#3f51b5' }}>Certificados:</Typography>
        {postulacion.archivos.certificadosUrls.map((url, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 2, width: '100%' }}>
                <Link href={url} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none', flexGrow: 1, mr: 2 }}>
                    <Button variant="contained" color="primary" startIcon={<CloudDownloadIcon />} fullWidth>
                        Certificado {index + 1}
                    </Button>
                </Link>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={documentosValidados.certificados?.[index]?.valido || false}
                                onChange={() => handleCheckboxChange("certificados", index, 'valido')}
                                color="success"
                                icon={<HighlightOffIcon sx={{ fontSize: 28 }} />}
                                checkedIcon={<CheckCircleOutlineIcon sx={{ fontSize: 28, color: 'green' }} />}
                            />
                        }
                        label={<Typography variant="body1" sx={{fontWeight: 500}}>Válido</Typography>}
                        
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={documentosValidados.certificados?.[index]?.invalido || false}
                                onChange={() => handleCheckboxChange("certificados", index, 'invalido')}
                                color="error"
                                icon={<HighlightOffIcon sx={{ fontSize: 28 }} />}
                                checkedIcon={<CheckCircleOutlineIcon sx={{ fontSize: 28, color: 'red' }} />}
                            />
                        }
                        label={<Typography variant="body1" sx={{fontWeight: 500}}>Inválido</Typography>}
                        
                    />
                </FormGroup>
            </Box>
        ))}
    </Paper>
</Grid>

                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}>Cerrar</Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}
